import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddVehicleCCRes;
export const AddVehicleCCTodo = createAsyncThunk('AddVehicleCC', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Post",
            url: process.env.REACT_APP_API_URL + 'vehicle_cc',
            data: {
                "vehicle_cc_name": data.cc,
                "vehicle_cc_status": data.status,
                "user_id": localStorage.getItem('user_id')
            },
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AddVehicleCCRes = res.data
        
    } catch (error) {
        return AddVehicleCCRes = error.response.data
    }
})
